import { SVGFC } from '@repo/toolkit/types'

const DocumentIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 13.8V10.2C4 6.8061 4 5.1087 5.04178 4.0548C6.08267 3 7.75911 3 11.1111 3H12.8889C16.2409 3 17.9173 3 18.9582 4.0548C19.5396 4.6425 19.7964 5.43 19.9093 6.6M20 10.2V13.8C20 17.1939 20 18.8913 18.9582 19.9452C17.9173 21 16.2409 21 12.8889 21H11.1111C7.75911 21 6.08267 21 5.04178 19.9452C4.46044 19.3575 4.20356 18.57 4.09067 17.4M8.44444 13.8H12.8889M8.44444 10.2H9.33333M15.5556 10.2H12"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default DocumentIcon
